import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';
import queryClient from '../../lib/queryClient';
import useDataDog from '../../reporting/DataDog';
import { QUERY_KEY_USER_TERMS } from './useTerms';

const useMarkTermsAsAcknowledged = () => {
  const { addError, addAction } = useDataDog();

  return useMutation({
    mutationKey: ['markTermsAsAcknowledged'],
    mutationFn: (termsDocumentUuid: string) => {
      return apiClient.post(`api/supplier-experience/user/terms/${termsDocumentUuid}/acknowledged`).json();
    },
    onSuccess: (_data, termsDocumentUuid) => {
      // we need to refetch the banner seen status to adjust the margin in app layout
      queryClient.refetchQueries({
        queryKey: [QUERY_KEY_USER_TERMS],
      });
      addAction('enterprise::user-terms::acknowledged::success', {
        message: `User terms ${termsDocumentUuid} marked as seen`,
        termsDocumentUuid,
      });
    },
    onError: (error, termsDocumentUuid) => {
      addError('enterprise::user-terms::acknowledged::error', {
        error,
        termsDocumentUuid,
      });
    },
  });
};

export default useMarkTermsAsAcknowledged;
